import type { SxProps, Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

/** Gentle scale pulse — works on FAB and bubble without fighting static box-shadow. */
export const launcherTeaserPulseAnimationSx = {
  animation: 'launcherTeaserPulse 2.5s ease-in-out infinite',
  '@keyframes launcherTeaserPulse': {
    '0%, 100%': { transform: 'scale(1)' },
    '50%': { transform: 'scale(1.04)' },
  },
} as const;

/** Expanding ring around the launcher (reference: light concentric pulse). */
export function launcherTeaserFabRingSx(primaryColor: string): SxProps<Theme> {
  return {
    position: 'relative',
    overflow: 'visible',
    ...launcherTeaserPulseAnimationSx,
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: -8,
      borderRadius: 'inherit',
      border: `2px solid ${alpha(primaryColor, 0.28)}`,
      animation: 'launcherTeaserFabRing 2.5s ease-out infinite',
      pointerEvents: 'none',
    },
    '@keyframes launcherTeaserFabRing': {
      '0%': { transform: 'scale(0.95)', opacity: 0.55 },
      '70%, 100%': { transform: 'scale(1.25)', opacity: 0 },
    },
  };
}

/** Message bubble chrome aligned with product mockup (white card, tail toward launcher). */
export const launcherTeaserBubbleChromeSx = {
  position: 'relative',
  maxWidth: 300,
  px: 2,
  py: 1.5,
  pr: 4.5,
  bgcolor: 'common.white',
  color: 'text.primary',
  borderRadius: '12px',
  boxShadow: '0 6px 20px rgba(0,0,0,0.12)',
  ...launcherTeaserPulseAnimationSx,
} as const;

/** Tail drawn on the open control so clicks there open chat. */
export const launcherTeaserBubbleTailSx = {
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: -7,
    right: 22,
    width: 14,
    height: 14,
    bgcolor: 'common.white',
    transform: 'rotate(45deg)',
    boxShadow: '3px 3px 4px rgba(0,0,0,0.06)',
  },
} as const;
